import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import { LENDER_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/lender-service-tags";

const getLender = lenderService.injectEndpoints({
  endpoints: builder => ({
    getLender: builder.query({
      query: id => `lenders/${id}`,
      providesTags: (result, error, id) => [{ type: LENDER_SERVICE_TAG, id }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLenderQuery } = getLender;

